<template>
  <div id="IBY-vitrine-holder">
    <div class="alert-message">
      <div class="alert-message-text">Seu E-Mail foi cadastrado com sucesso!</div>
    </div>
    <div id="IBY-vitrine" class="IBY">
      <div class="IBY-container">
        <div @click="prev" class="SBY-prev"></div>
        <div @click="next" class="SBY-next"></div>

        <div class="IBY-vitrine-list" style="display: -webkit-box;">
          <div class="IBY-vitrine-item" v-for="produto in produtos" :key="produto.id">
            <div class="IBY-vitrine-imagem" :style='{backgroundImage: "url("+produto.image_high.url+")"}'>
              <a style="text-decoration: none; color:#333;" :href="produto.link" v-if="produto.kind == 'link'" class="IBY-vitrine-link" :data-produto="produto.id">
                <p style="color:#333 !important; margin-bottom:0.3em !important;"><i style="color:#333;" class="fa fa-heart"></i> {{produto.source.likes.count}}</p>
              </a>
              <a style="text-decoration: none; color:#333;" v-if="produto.kind == 'alert'" class="IBY-vitrine-link alert toggle-modal" :data-produto="produto.id">
                <div class='hover-alert text-center' style='cursor:pointer;'>
                  <div class="title">{{produto.alert.title}}</div>
                  <div class="description">{{produto.alert.description}}</div>
                </div>
              </a>
              <a v-if="produto.kind == 'looks'" v-on:click="show = !show" class="IBY-vitrine-link toggle-modal" :data-produto="produto.id">
                <p style="color:#333 !important; margin-bottom:0.3em !important;"><i style="color:#333;" class="fa fa-heart"></i> {{produto.source.likes.count}}</p>
              </a>
            </div>
          </div>
        </div>

      </div>
    </div>


    <div   :v-if="show == true" v-for="produto in produtos" class="IBY-modal-main" :id='"IBY-modal-"+produto.id' style='display:none;' :key="produto.id">
    <div >
      <div v-if="produto.kind == 'looks'" class="IBY-modal-container">
        <span class="IBY-controls IBY-prev" v-bind:data-go="produto.id"></span>

        <div class="IBY-modal">
          <div class="powered-by">Powered By <img src="https://socbuy.kauamanga.com.br/assets/powered-by-socialbuy.png"></div>
          <div class="IBY-modal-close" :data-modal="produto.id" v-on:click="show = false;">&times;</div>

          <div class="IBY-modal-image">
            <div style="position:relative; max-width:400px;">
              <img :src="produto.image_high.url">
              <a v-for="look in produto.looks" :href="look.link" class="IBY-look-index" :style='{left: look.x+"%", top: look.y+"%"}' :key="look.idx">{{look.idx}}</a>
            </div>
          <div class="IBY-user">
            <img :src="produto.source.user.profile_picture">
            <a :href='"https://instagram.com/"+produto.source.user.username'>@{{produto.source.user.username}}</a>
          </div>
          <p class="IBY-product-caption">{{produto.description}}</p>
          </div>

          <div class="IBY-modal-produtos">
            <h4>SHOP THE LOOK</h4>
              <div v-for="look in produto.looks" class="IBY-modal-product" style="position:relative;" :key="look.idx">
                <a class="IBY-product-details-image" :href='look.link'>
                  <img :src='look.image'>
                </a>
                <div class="IBY-product-details" style="position:relative;">
                  <p>
                    <a class="IBY-product-title" :href="look.link">{{look.name}}</a>
                  </p>
                  <a class="IBY-product-button" :href="look.link">comprar</a>
                </div>
                <span class="IBY-look-index" style="top:2px; left:2px;">{{look.idx}}</span>
              </div>
          </div>
        </div>

        <span class="IBY-controls IBY-next" :data-go="produto.id"></span>
      </div>
 
      <div v-if="produto.kind == 'alert'" class="IBY-modal-container">
        <span class="IBY-controls IBY-prev" v-bind:data-go="produto.id"></span>

        <div class="IBY-modal">
          <div class="powered-by">Powered By <img src="https://socbuy.kauamanga.com.br/assets/powered-by-socialbuy.png"></div>
          <div class="IBY-modal-close" :data-modal="produto.id" >&times;</div>

          <div class="IBY-modal-image">
            <div style="position:relative; max-width:400px;">
              <img :src="produto.image_high.url">
              <a v-for="look in produto.looks" :href="look.link" class="IBY-look-index" :style='{left: look.x+"%", top: look.y+"%"}' :key="look.idx">{{look.idx}}</a>
            </div>
          <div class="IBY-user">
            <img :src="produto.source.user.profile_picture">
            <a :href='"https://instagram.com/"+produto.source.user.username'>@{{produto.source.user.username}}</a>
          </div>
          <p class="IBY-product-caption">{{produto.description}}</p>
          </div>

          <div class="IBY-modal-produtos">
            <div class='IBY-modal-products'>
              <h4 style='text-align:center; margin-bottom:1em; color:#333;'>{{produto.alert.title}}</h4>
              <p style='text-align:center;'>{{produto.alert.description}}</p>
              <input type='text' name='email' id='email' placeholder="Seu email pessoal">
              <button style='width:100%; margin-top:1em;' class="IBY-product-button avisar">
                  CADASTRAR
              </button>
            </div>
          </div>
        </div>

        <span class="IBY-controls IBY-next" :data-go="produto.id"></span>
      </div>
      </div> 
    </div>
    </div>

  </div>
</template>



<script>
export default {
  name: 'IBY-BASE',
  data () {
    return {
      storename: $('#SBY-holder').attr('data-storename'),
      showcase_id: $('#SBY-holder').attr('data-showcase'),
      produtos: [],
      produtos_ids: [],
      page: 20,
      timeout: 0,
      timeoutTime: 4000,
      timeoutTimeStart: 0,
      timeoutIndex: 0,
      productWidth: 304,
      maxProducts: 4,
      show: false
    }
  },
computed: {
    productLimit: function(){
      var qtd;
      var max;
      if($(window).width() <= 480){
        qtd = this.produtos.length;
        max = 2;
      }else{
        qtd = this.produtos.length;
        max = this.maxProducts;
      }
      return qtd - max;
    }
  },
  mounted: function()
  {
    this.init();
    this.open();
    // this.login();
    this.close();
    this.nextmodal();
    this.prevmodal();
    this.enviarBoxAviseme();
  },
  methods:
  {
    init: function() {
      const instance = this;
      const storename = this.storename;
      const urlPagina = window.location.href;
      const regex = /^.*[\?\&]utm_source=(.*)\&?.*/
      const utmCliente = urlPagina.replace(regex, '$1');
      const url = "https://" + storename + ".socbuy.kauamanga.com.br/api/v1/public/showcase/" + instance.showcase_id + ".json?per_page=" + instance.page;
      console.log(url);

      instance.$http.get(url)
      .then(response => {
        instance.produtos = response.body.data;
        instance.page++;
        // console.log(instance.produtos);
        response.body.data.forEach(function(element, index){
          instance.produtos_ids.push(element.id);
        });
        instance.start();
      }, response => {
        // console.log(response);
      });
    },
    enviarBoxAviseme: function() {
      const instance = this;
        $('.avisar').on('click', function() {
            var email = $("#email").val();
            if (email.length > 0) {
                $.ajax({
                    url: "https://" + instance.storename + '.socbuy.kauamanga.com.br/api/v1/public/alert',
                    type: "POST",
                    data: {
                        email: email
                    },
                    error: function() {
                      console.log('erro no envio');
                    },
                    success: function(data) {

                      var produto = $(this).data('modal'); //ID do produto (modal atual)
                      $("body").removeClass('body-no-overflow');
                      $(".IBY-modal-main").fadeOut('fast');

                      $('.alert-message').fadeIn('fast');
                      setTimeout(function() {
                          $('.alert-message').fadeOut();
                      }, 2000);
                    }
                });
            } else {
                alert("digite um e-mail")
            }
        })
    },
   open: function () {
     const instance = this;
      $('body').on("click", ".IBY-vitrine-link.toggle-modal", function() {
        var produto = $(this).data('produto');
        // $("body").removeClass('body-no-overflow');
        $("#IBY-modal-"+produto).fadeIn('fast');
        // instance.enviarBoxAviseme();
        instance.currentProduct = produto;
      })
    },
    close: function () {
      const instance = this;
      function closeIt() {
        var produto = $(this).data('modal') || $(this).find('.IBY-modal-close').data('modal'); //ID do produto (modal atual)
        $("body").removeClass('body-no-overflow');
        $("#IBY-modal-"+produto).fadeOut('fast');
      }

      $("body").on("click", ".IBY-modal-main", function(e) {
        // $('.IBY-modal-main').hide();
        const $target = $(e.target)
        const shouldClose = $target.hasClass('IBY-modal-close') || $target.closest('.IBY-modal').length === 0
        if (!shouldClose) { return; }
        closeIt.call(this)
      });
      $(document).on('keydown', function(e){
        if(e.which === 27) {
          const modal = $('.IBY-modal-main').filter(function() { return $(this).css('display') != 'none'; });
          if(modal.length) { closeIt.call(modal.get(0)); }
        }
      });
    },
    nextmodal: function () {
      const cont = this.produtos_ids;
      $("body").on('click', ".IBY-next", function(e){
        var id = $(this).data('go');
        var index = cont.indexOf(id)+1 != -1 ? cont.indexOf(id)+1 : "falso";
        if(index != "falso"){
          $('#IBY-modal-'+id).fadeOut('fast');
          $("#IBY-modal-"+cont[index]+"").fadeIn('fast');
        }
      });
    },
    prevmodal: function () {
      const cont = this.produtos_ids;
      $("body").on('click', ".IBY-prev", function(e){
        var id = $(this).data('go');
        var index = cont.indexOf(id)-1 != -1 ? cont.indexOf(id)-1 : "falso";
        if(index != "falso"){
          $('#IBY-modal-'+id).fadeOut('fast');
          $("#IBY-modal-"+cont[index]+"").fadeIn('fast');
        }
      });
    },
    start: function(){
      const carousel = this;
      // console.log(carousel);
      this.startTimeout();

      $('body').on('mouseover', '.IBY-vitrine-item', function() {
        carousel.stopTimeout();
      });
      $('body').on('mouseout', '.IBY-vitrine-item', function() {
        carousel.startTimeout();
      });
      // $('#vitrine').css('opacity', 1);
       setTimeout(function(){
          $(".IBY-vitrine-imagem").each(function(idx, el){
            $('.IBY').height($(el).width());
          });
        }, 1000);

      $(window).resize(function(){
        setTimeout(function(){
          $(".IBY-vitrine-imagem").each(function(idx, el){
            $('.IBY').height($(el).width());
          });
        }, 1000);
      })
    },
    startTimeout: function (){
      const carousel = this;
      this.stopTimeout();
      this.timeout = setInterval(function(){
        carousel.processTimeout();
        // console.log('ticked');
      }, carousel.timeoutTime);
    },
    stopTimeout: function () {
      clearTimeout(this.timeout);
    },
    processTimeout: function (){
      const carousel = this;
      if(carousel.timeoutIndex < carousel.productLimit){
        carousel.productWidth = $(".IBY-vitrine-item:first-child").width();
        $(".IBY-vitrine-item").each(function(idx, el){
          $(el).animate({ left: '-='+(carousel.productWidth + 6) }, 1000);
        });
        carousel.timeoutIndex++;
      }else{
        $(".IBY-vitrine-item").each(function(idx, el){
          $(el).animate({ left: '0' }, 1000);
        });
        carousel.timeoutIndex = 0;
      }
    },
    next: function (){
      this.stopTimeout();
      this.processTimeout();
      this.startTimeout();
    },
    prev: function (){
      this.stopTimeout();
      const carousel = this;
      if(carousel.timeoutIndex > 0){
        $(".IBY-vitrine-item").each(function(idx, el){
          $(el).animate({ left: '+='+(carousel.productWidth + 6) }, 1000);
        });
        carousel.timeoutIndex--;
      }else{
        $(".IBY-vitrine-item").each(function(idx, el){
          $(el).animate({ left: '0' }, 1000);
        });
        carousel.timeoutIndex = 0;
      }
      this.startTimeout();
    }
  }
}
</script>


<style scoped src="./assets/css/style.css"></style>



// WEBPACK FOOTER //
// src/App.vue